import store from "../vuex/store";
import NcmUsuarioService from "../services/NcmUsuarioService";
import swal from "sweetalert";

const beforeEach = async (to, from, next) => {
  try {

    const publicRoutes = ['/login', '/security/password']

    if (publicRoutes.some(route => to.path.includes(route))) {
      return next()
    }

    const auth = to.meta.requiresAuth;
    let loggedUser = store.getters.getUser || {};
    let selectedCompany = store.getters.getCompany;
    const token = store.getters.getToken;

    document.title = `NCM Helper - ${to.meta.label}`;

    if (!auth) return next();

    if (token && token.toLowerCase() !== "null") {
      if (!loggedUser.basic || !loggedUser.basic.idUsuario) {
        const response = await NcmUsuarioService.getUserInfo();
        loggedUser = response.body;
        store.dispatch("setUser", loggedUser);
      }
    } else {
      loggedUser = {};
      selectedCompany = {};
      store.dispatch("setUser", {});
      store.dispatch("setCompany", {});
    }

    if (!loggedUser.basic || !loggedUser.basic.idUsuario) {
      return next({ name: "Login" });
    }

    const userLevel = loggedUser?.level?.idNivel;

    if (to.meta.permissions?.some((x) => x === userLevel)) {
      next();
    } else {
      swal(
        "Planos Assessoria",
        "Você não tem permissão para acessar esse módulo!",
        "warning"
      );
      return next({ path: "/" });
    }

    if (!selectedCompany?.hasOwnProperty("id")) {
      if (to.meta.requiresCompany) {
        swal(
          "Planos Assessoria",
          "Você deve selecionar uma empresa para continuar!",
          "warning"
        );
        return next({ path: "/" });
      }
    }

    next();

  } catch (e) {
    console.error(e);
    next({ path: "/login" });
  }
};

export default beforeEach;
